export default "__VITE_ASSET__DgOItkeb__"